module.exports = __webpack_public_path__ + "img/laboratory-banner.7a4bebc6.png";